import React from "react";
import styles from "../../assets/scss/pages.module.scss";
import { useNavigate } from "react-router-dom";

const MyProfileArtworksPage = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.myProfileArtworksPageContainer}>
      <div>
        <button onClick={() => navigate("/my-profile/add-artwork")}>
          Add new artwork
        </button>
      </div>
    </div>
  );
};

export default MyProfileArtworksPage;
